import { call } from '../../utils/serviceUtils';
import {
  PARAMETER,
  PARAMETERS_BY_GROUP_CODES
  } from '../../config/paths';

export function getParameterByGroupCode(code) {
  return call.get(PARAMETER + '/' + code,
    {

    });
}

export function getParametersByGroupCodes(codes) {
  return call.post(PARAMETERS_BY_GROUP_CODES,codes);
}

export function postParametersByGroupCodes() {
  return call.post("/easysignapi/v1/Parameters");
}

